var EditingModule = angular.module('EditingModule', []);


/**
 * slotFullHeight
 *
 * set the slot height to the highest slot height in the row except separators or spacer-slots
 */
EditingModule.directive('slotFullHeight', [function () {
    return {
        restrict: 'A',
        link: function (scope, _element) {
            var element = _element[0];
            var parent = scope.editing.findParentWithClass(element, 'row');

            function update() {
                var height = scope.editing.getRowHeight(parent, 30, ['empty', 'spacer', 'separator']);
                if (height != element.dataHeight) {
                    element.dataHeight = height;
                    element.style.height = (height) + 'px';
                }
            }

            var interval = setInterval(update, 800);
            scope.$on('$destroy', function () {
                clearInterval(interval);
            });
        }
    };
}]);


/**
 * EditingService
 */
EditingModule.service('EditingService', ['overlay', '$rootScope', 'messages', function (overlay, $rootScope, messages) {
    /** @type {{mode: Object.<string, boolean>, sections: [msSection]}|angular.$$scope} */
    var currentScope = null;

    // helper
    function objSettingsClassAdd(obj, class_string) {
        if (!obj.settings) obj.settings = {};
        if (!obj.settings.classes) obj.settings.classes = [];
        if (obj.settings.classes.indexOf(class_string) == -1) obj.settings.classes.push(class_string);
    }

    function objSettingsClassRemove(obj, class_string) {
        if (!obj.settings || !obj.settings.classes) return;

        var index = obj.settings.classes.indexOf(class_string);
        if (index >= 0) obj.settings.classes.splice(index, 1);
    }

    /**
     * returns the absolute position of the element `el` or null on error
     *
     * @param el {HTMLElement}
     * @returns {null|{left:Number, top:Number, width:Number, height:Number}}
     */
    function domElementOffsetPosition(el) {
        if (!el) return null;
        var _x = 0, _y = 0, _w = el.offsetWidth, _h = el.offsetHeight;
        while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return {left: _x, top: _y, width: _w, height: _h};
    }

    /**
     * returns itself or the next parent which has the class `class_to_find`
     *
     * @param start_element {HTMLElement}
     * @param class_to_find {String}
     * @returns {HTMLElement}
     */
    function findParentWithClass(start_element, class_to_find) {
        while (start_element && (start_element.classList + ' ').indexOf(class_to_find + ' ') < 0) {
            //noinspection JSUnresolvedVariable
            start_element = start_element.parentElement;
        }
        return start_element;
    }


    function findChildWithClass(start_element, class_to_find) {
        while (start_element && (start_element.classList + ' ').indexOf(class_to_find + ' ') < 0) {
            if (!start_element.children.length) {
                return null;
            }
            start_element = start_element.children[0];
        }
        return start_element;
    }

    function findParentWithTag(start_element, tag_to_find) {
        while (start_element && start_element.tagName != tag_to_find.toUpperCase()) {
            start_element = start_element.parentElement;
        }
        return start_element;
    }

    function findChildWithTag(start_element, tag_to_find) {
        while (start_element && start_element.tagName != tag_to_find.toUpperCase()) {
            if (!start_element.children.length) {
                return null;
            }
            start_element = start_element.children[0];
        }
        return start_element;
    }

    /**
     * return: true if the row contains no wrapping children.
     *
     * @param element {HTMLElement}
     * @returns {boolean}
     */
    function isOneRow(element) {
        if (!element || !element.children) return false;
        var last_pos = null;
        for (var i = 0; i < element.children.length; i++) {
            var pos = element.children[i].getBoundingClientRect().top;
            if (last_pos && pos != last_pos) {
                return false;
            }
            last_pos = pos;
        }
        return true;
    }

    /**
     * getRowHeight - returns the height of the highest slot except slots with type set by ignore_types
     * @param row_element {HTMLElement}
     * @param default_height {undefined|number}
     * @param ignore_types {undefined|[String]}
     * @returns {number}
     */
    function getRowHeight(row_element, default_height, ignore_types) {
        var height = default_height | 0;
        if (!row_element) return height;
        for (var i = 0; i < row_element.children.length; i++) {
            var child = row_element.children[i];
            if (ignore_types && ignore_types.indexOf(child.dataset.type) >= 0) continue;
            var rect = findChildWithClass(child, 'slot');
            if (rect) rect = rect.getBoundingClientRect();
            if (rect && rect.height > height) height = rect.height;
        }
        return height;
    }

    /** @namespace editingCol */
    var editing = {
        /**
         * @param $scope
         * @returns {editingCol|{}}
         */
        initialize: function ($scope) {
            currentScope = $scope;
            currentScope.$on('$destroy', function () {
                currentScope = null;
            });
            return editing;
        },

        findChildWithClass: findChildWithClass,
        findChildWithTag: findChildWithTag,
        findParentWithClass: findParentWithClass,
        findParentWithTag: findParentWithTag,
        isOneRow: isOneRow,
        getRowHeight: getRowHeight,

        mode: 'select',
        /** @type {null|msSection} */
        section: null,
        /** @type {null|msGroup} */
        group: null,
        /** @type {null|msSlot} */
        slot: null,
        data: null,

        last_mode: null,
        /** @type {null|msSection} */
        last_section: null,
        /** @type {null|msGroup} */
        last_group: null,
        /** @type {null|msSlot} */
        last_slot: null,
        last_data: null,

        slot_options: [],

        /**
         * the editing modes/phases.
         *
         * editing.switchMode(new_mode/next_phase [, data]) - set the next mode/phase
         * editing.modes.***.start(): called by editing.switchMode()
         * editing.modes.***.action(section, group, slot, evt, after): called if a slot/group/section got clicked
         * editing.modes.***.stop(): called before switching to another mode/phase
         */
        modes: {
            edit: {
                start: function () {
                },
                action: function (section, group, slot, evt) {
                    if (evt && evt.target && ((evt.target.classList + "").indexOf('btn') >= 0 || (evt.target.classList + "").indexOf('fa') >= 0)) {
                        return;  // ignore if event==click on button
                    }

                    if (editing.slot == slot && editing.group == group && editing.section == section) {
                        return;
                    }
                    editing.modes.edit.stop();

                    if (slot) {
                        slot.edit = true;
                        messages.notify('edit-slot-' + slot.type);
                    } else if (group) {
                        group.edit = true;
                        messages.notify('edit-group');
                    } else if (section) {
                        section.edit = true;
                        messages.notify('edit-section');
                    }


                    editing.section = section;
                    editing.group = group;
                    editing.slot = slot;
                },
                stop: function () {
                    messages.hide();
                    // clear slot options (the slot should clean up its options)
                    editing.slot_options = [];

                    var subject = null;

                    if (editing.slot) {
                        subject = editing.slot;
                    } else if (editing.group) {
                        subject = editing.group;
                    } else if (editing.section) {
                        subject = editing.section;
                    }

                    if (subject) {
                        subject.edit = false;
                    }
                }
            },
            addSlot: {
                start: function () {
                    messages.show('select-slot-insert-area');
                },
                action: function (section, group, slot, evt, after) {
                    var new_slot = editing._insertSlot(section, group, slot, editing.data, after && slot);
                    editing.switchMode('select');
                    editing.handle(section, group, new_slot, null, 'addSlot.action');
                },
                stop: function () {
                    messages.hide();
                }
            },
            addGroup: {
                start: function () {
                    messages.show('select-separator-insert-area');
                },
                action: function (section, group, slot, evt, after) {
                    var new_group = editing._insertGroup(section, group, slot, after);
                    editing.switchMode('select');
                    editing.handle(section, new_group, null, null, 'addGroup.action');
                    //if (new_group.slots.length === 0) currentScope.showGridBottomSheet(null, true);
                },
                stop: function () {
                    messages.hide();
                }
            },
            addSection: {
                start: function () {
                    messages.show('select-section-insert-area');
                },
                action: function (section, group, slot, evt, after) {
                    var section_number = currentScope.sections.length;
                    var new_section = editing._insertSection(section, {
                        type: section.type, settings: {
                            title: 'Neuer Title ' + section_number,
                            slug: 'neuer-title-' + section_number
                        }, groups: [
                            {
                                slots: []
                            },
                            {
                                slots: []
                            }
                        ]
                    }, after);

                    editing._insertSlot(new_section, new_section.groups[0], 1, {
                        type: 'headline',
                        content: 'Neue Überschrift ' + section_number,
                        settings: {classes: ['align-center']}
                    }, true);

                    editing._insertSlot(new_section, new_section.groups[1], 1, {
                        type: 'text',
                        content: 'text slot',
                        settings: {classes: ['align-center']}
                    }, true);

                    editing._insertSlot(new_section, new_section.groups[1], 1, {
                        type: 'image',
                        content: '/img/default/image-placeholder-16-9.png'
                    }, true);

                    editing.switchMode('select');
                    setTimeout(function () {
                        editing.handle(new_section, null, null, null, 'addSection.action');
                    }, 32);
                },
                stop: function () {
                    messages.hide();
                }
            },
            select: {
                /**
                 * desc: default mode
                 * does: starts the edit-phase if a element got clicked
                 */
                start: function () {
                },
                action: function (section, group, slot) {
                    editing.switchMode('edit');
                    editing.handle(section, group, slot, null, 'select.action');
                },
                stop: function () {
                }
            },
            copy: {
                start: function () {
                    messages.show('copy-mode');
                },
                action: function (section, group, slot, evt, after) {
                    if (editing.last_slot) {
                        var new_slot = editing._insertSlot(section, group, slot, angular.copy(editing.last_slot), after);
                        editing.switchMode('select');
                        editing.handle(section, group, new_slot, null, 'copy.action');

                    } else if (editing.last_group) {
                        var new_group = editing._insertGroup(section, group, slot, after);
                        editing.switchMode('select');
                        editing.handle(section, new_group, null, null, 'copy.action');

                    } else if (editing.last_section) {
                        var new_section = editing._insertSection(section, angular.copy(editing.last_section), after);
                        editing.switchMode('select');
                        editing.handle(new_section, null, null, null, 'copy.action');
                    }
                },
                stop: function () {
                    messages.hide();
                }
            },
            cut: {
                start: function () {
                    if (editing.last_slot) {
                        objSettingsClassAdd(editing.last_slot, 'cut-action');
                    }
                    messages.show('cut-mode');
                },
                action: function (section, group, slot, evt, after) {
                    var sec = editing.last_section, gr = editing.last_group, sl = editing.last_slot;
                    if (sl) {
                        objSettingsClassRemove(editing.last_slot, 'cut-action');
                        var new_slot = editing._insertSlot(section, group, slot, angular.copy(editing.last_slot), after);
                        editing._removeSlot(sec, gr, sl);
                        editing.switchMode('select');
                        editing.handle(section, group, new_slot, null, 'cut.action');
                    } else if (gr) {
                        var new_group = editing._insertGroup(section, group, slot, after);
                        editing._removeSeparator(sec, gr);
                        editing.switchMode('select');
                        editing.handle(section, new_group, null, null, 'cut.action');
                    } else if (sec) {
                        var new_section = editing._insertSection(section, angular.copy(editing.last_section), after);
                        editing._removeSection(sec);
                        editing.switchMode('select');
                        editing.handle(new_section, null, null, null, 'cut.action');
                    }
                    // messages.notify('paste-confirm');
                },
                stop: function () {
                    messages.hide();

                    if (editing.last_slot) {
                        objSettingsClassRemove(editing.last_slot, 'cut-action');
                    }
                }
            }
        },

        /**
         * click on background should deselect items
         * @param event {Event}
         */
        onMainClick: function (event) {
            if (event && event.type == 'focus') return;

            if (event && editing.mode == 'edit' && (event.target.classList + ' ').indexOf('section ') >= 0) {
                if (event.type != 'focus') {
                    editing.switchMode('select');
                }
            }
        },

        _stashedSubject: null,
        _stashSelection: function () {
            var subject = null;

            if (editing.slot) {
                subject = editing.slot;
            } else if (editing.group) {
                subject = editing.group;
            } else if (editing.section) {
                subject = editing.section;
            }

            if (subject && subject.edit === true) {
                editing._stashedSubject = subject;
                subject.edit = false;
            } else {
                editing._stashedSubject = null;
            }

        },
        _pop_selection: function () {
            if (editing._stashedSubject) {
                editing._stashedSubject.edit = true;
                editing._stashedSubject = null;
            }
        },

        /**
         * @param section {msSection}
         * @param event {Event}
         */
        onSectionLabelClick: function (section, event) {
            if (!currentScope.mode.edit) return;
            if (event && event.type == 'focus') return;

            if (editing.mode == 'edit') {
                if (section === editing.section && !editing.slot && !editing.group) {
                    editing.switchMode('select');
                } else {
                    editing.switchMode('select');
                    setTimeout(function () {
                        editing.handle(section, null, null, event, 'onSectionLabelClick');
                        currentScope.$applyAsync();
                    });
                }
            } else {
                editing.handle(section, null, null, event, 'onSectionLabelClick');
            }
        },

        /**
         * @param section {msSection}
         * @param event {Event}
         */
        onSectionClick: function (section, event) {
            if (!currentScope.mode.edit) return;
            if (event && event.type == 'focus') return;
            if (event && event.target && event.target.nodeName == 'SMALL') return;

            if (editing.mode != 'edit' && editing.mode != 'select' && event) {
                editing.handle(section, null, null, event, 'onSectionClick');
            } else {
                if ((event.target.classList + ' ').indexOf('row ') >= 0 || (event.target.classList + ' ').indexOf('container ') >= 0) {
                    if (editing.mode == 'edit') {
                        editing.switchMode('select');
                    } else {
                        if (section === editing.section && !editing.slot && !editing.group) {
                            editing.switchMode('select');
                        } else {
                            editing.switchMode('select');
                            editing.handle(section, null, null, event, 'onSectionLabelClick');
                        }
                    }
                }
            }
        },

        /**
         * @param section {msSection}
         * @param group {msGroup}
         * @param event {Event}
         */
        onGroupClick: function (section, group, event) {
            if (event && event.type == 'focus') return;

            if (currentScope.mode.edit) {
                editing.handle(section, group, null, event, 'onGroupClick');
            }
        },

        /**
         * @param section {msSection}
         * @param group {msGroup}
         * @param slot {msSlot}
         * @param event {Event}
         */
        onSlotClick: function (section, group, slot, event) {
            if (event && event.type == 'focus') return;
            if (!currentScope.mode.edit) return;

            if (editing.mode == 'edit') {
                if (section != editing.section || group != editing.group || slot != editing.slot) {
                    editing.switchMode('select');
                    editing.handle(section, group, slot, event, 'onSlotClick');
                }
            } else {
                editing.handle(section, group, slot, event, 'onSlotClick');
            }
        },

        openStuff: function (section, group, slot) {
            editing.switchMode('select');
            editing.handle(section, group, slot, null, 'openStuff');
            currentScope.showGridBottomSheet(null, true, function () {
                editing._removeSlot(section, group, slot);
            });
        },

        /**
         * triggers modes.***.action(...)
         * detect clicks before/after above/under elements
         * @param section {msSection}
         * @param group {msGroup}
         * @param slot {msSlot}
         * @param [evt] {Event}
         * @param [cause] {String}
         */
        handle: function (section, group, slot, evt, cause) {
            if (evt && evt.type != 'focus' && editing.mode != 'select' && !group && !slot && (evt.target.classList + ' ').indexOf('section ') == -1 && (evt.target.classList + ' ').indexOf('container ') == -1) {
                return; // ignore section click event if section is not the target
            }

            if (editing.mode == 'edit') editing._scrollTo(section, group, slot);

            function detectClick(evt, slot, group, section) {
                if (!evt || editing.mode == 'edit' || editing.mode == 'select') return true;

                var action = 'right';
                var target, rect, xPercent, yPercent;
                if (slot) {
                    // calculate insert position... 'left' = before clicked slot, 'right' = after clicked slot, default = 'right'
                    target = evt.toElement;
                    if (!target) target = evt.target;

                    var element = findParentWithClass(target, 'slot');
                    if (!element) element = findChildWithClass(target, 'slot');
                    var parent = findParentWithClass(element, 'row');
                    if (element && parent) {
                        var left_right = editing.isOneRow(parent);
                        var top_bottom = parent.children.length == 1 || left_right === false;
                        rect = element.getBoundingClientRect();
                        xPercent = (((evt.clientX - rect.left) / rect.width) * 100 - 50) | 0;
                        yPercent = (((evt.clientY - rect.top) / rect.height) * 100 - 50) | 0;
                        if (left_right) left_right = xPercent < 0 ? 'left' : 'right';
                        if (top_bottom) top_bottom = yPercent < 0 ? 'left' : 'right';
                        action = left_right ? left_right : top_bottom;
                        if (left_right && top_bottom) {
                            action = Math.abs(xPercent) > Math.abs(yPercent) ? left_right : top_bottom;
                        }
                    }
                } else if (section && !group) {
                    target = evt.toElement;
                    if (!target) target = evt.target;
                    rect = target.getBoundingClientRect();
                    yPercent = (((evt.clientY - rect.top) / rect.height) * 100 - 50) | 0;
                    action = yPercent < 0 ? 'left' : 'right';
                }
                return action == 'right';
            }

            var mode = editing.mode;
            $rootScope.$broadcast('msModeHandle', mode, section, group, slot, evt);
            editing.modes[editing.mode].action(section, group, slot, evt, detectClick(evt, slot, group, section));
            $rootScope.$broadcast('msModeHandled', mode, section, group, slot, evt);
        },

        /** @param [evt] {Event} */
        handleWithLastSelection: function (evt) {
            editing.handle(editing.last_section, editing.last_group, editing.last_slot, evt, 'handleWithLastSelection');
        },


        _mode_start: function () {
            if (['addSlot'].indexOf(editing.mode) >= 0) {
                overlay.show('insert type-slot');

            } else if (['addGroup'].indexOf(editing.mode) >= 0) {
                overlay.show('insert type-group');

            } else if (['addSection'].indexOf(editing.mode) >= 0) {
                overlay.show('insert type-section');

            } else if (['copy', 'cut'].indexOf(editing.mode) >= 0) {
                overlay.show('insert type-' + editing.getLastType());
            }
            editing.modes[editing.mode].start();
        },

        _mode_stop: function () {
            overlay.hide();
            editing.modes[editing.mode].stop();
        },

        /**
         * @param new_mode {string}
         * @param [data] {object}
         */
        switchMode: function (new_mode, data) {
            if (new_mode == editing.mode) {
                return;
            }

            // todo console.log('switch mode from >' + editing.mode + '< to >' + new_mode + '<');

            editing._mode_stop();
            editing.last_section = editing.section;
            editing.last_group = editing.group;
            editing.last_slot = editing.slot;
            editing.last_mode = editing.mode;
            editing.last_data = editing.data;
            editing.section = null;
            editing.group = null;
            editing.slot = null;
            editing.mode = new_mode;
            editing.data = data;
            editing._mode_start();
            $rootScope.$broadcast('msModeSwitched', new_mode);
        },

        remove: function () {
            if (editing.slot) {
                editing.removeSlot();

            } else if (editing.group) {
                editing._removeSeparator(editing.section, editing.group);

            } else if (editing.section) {
                editing._removeSection(editing.section);
            } else {
                return;
            }
            messages.notify('delete-confirm');
        },
        removeGroup: function () {
            editing._removeGroup(editing.section, editing.group);
        },
        removeSlot: function () {
            editing._removeSlot(editing.section, editing.group, editing.slot);
        },

        insertSlot: function (type, after) {
            var slot = {type: type};

            editing._insertSlot(editing.section, editing.group, editing.slot, slot, after);
        },

        /**
         * @param {string} type - main|footer
         * @returns {number}
         */
        count_sections: function (type) {
            var count = 0;
            currentScope.sections.forEach(function (section) {
                if (section.type == type) count += 1;
            });
            return count;
        },

        /** @param section {msSection} */
        _removeSection: function (section) {
            if (section == editing.section) {
                editing.switchMode('select');
            }
            if (currentScope.sections.indexOf(section) >= 0) {
                var removed = currentScope.sections.splice(currentScope.sections.indexOf(section), 1);
                removed = removed[0];
                if (removed.type == 'main' && editing.count_sections('main') === 0) {
                    var new_section = editing._insertSection(section, {
                        type: section.type, settings: {
                            title: 'Neuer Title 1',
                            slug: 'neuer-title-1'
                        }, groups: [
                            {
                                slots: []
                            },
                            {
                                slots: []
                            }
                        ]
                    }, true);

                    editing._insertSlot(new_section, new_section.groups[0], 1, {
                        type: 'headline',
                        content: 'Neue Überschrift 1',
                        settings: {classes: ['align-center']}
                    }, true);

                    editing._insertSlot(new_section, new_section.groups[1], 1, {
                        type: 'text',
                        content: 'text slot',
                        settings: {classes: ['align-center']}
                    }, true);
                }
            }
        },
        _removeGroup: function (section, group) {
            if (group == editing.group) {
                editing.switchMode('select');
            }
            section.groups.splice(section.groups.indexOf(group), 1);
            if (section.groups.length === 0) {
                editing._removeSection(section);
            }
        },
        _removeSeparator: function (section, group) {
            var group_index = section.groups.indexOf(group) - 1;
            if (group_index < 0) group_index = 0;
            var copy = angular.copy(group.slots); // copy slots
            editing._removeGroup(section, group); // remove group
            section.groups[group_index].slots = section.groups[group_index].slots.concat(copy); // concat copied slots
        },
        _removeSlot: function (section, group, i_or_slot) {
            var slot_index = i_or_slot;
            if (angular.isObject(i_or_slot)) {
                slot_index = group.slots.indexOf(i_or_slot);
            }

            if (group.slots[slot_index] == editing.slot) {
                editing.switchMode('select');
            }

            setTimeout(function () {
                group.slots.splice(slot_index, 1);
                if (group.slots.length === 0) {
                    editing._removeGroup(section, group);
                }
                currentScope.$applyAsync();
            }, 1);
        },

        /**
         * @param section {msSection}
         * @param [group] {msGroup}
         * @param [slot] {msSlot}
         * @returns {null|HTMLElement}
         */
        _getElement: function (section, group, slot) {
            var section_i = currentScope.sections.indexOf(section);
            var group_i = group ? section.groups.indexOf(group) : null;

            if (slot) {
                return null;
            } else if (group) {
                return document.getElementById('group-' + section_i + '-' + group_i);
            } else {
                return document.getElementById('section-' + section_i);
            }
        },

        getType: function () {
            if (editing.slot) {
                return 'slot';
            } else if (editing.group) {
                return 'group';
            } else if (editing.section) {
                return 'section';
            } else {
                // todo: console.log('error! editing.getType()...');
                return '';
            }
        },
        getLastType: function () {
            if (editing.last_slot) {
                return 'slot';
            } else if (editing.last_group) {
                return 'group';
            } else if (editing.last_section) {
                return 'section';
            } else {
                // todo: console.log('error! editing.getLastType()...');
                return '';
            }
        },

        _scrollTo: function (section, group, slot) {
            setTimeout(function () {
                var rect = domElementOffsetPosition(editing._getElement(section, group, null)); // TODO replace _getElement


                if (!slot && group) {
                    rect.top -= 200;
                }

                if (rect) {
                    var viewPos = document.getElementById('site').scrollTop;
                    var viewPosEnd = viewPos + window.innerHeight;
                    if (rect.top - 200 < viewPos || rect.top + 150 > viewPosEnd) {
                        //$('md-content').animate({scrollTop: rect.top - 150});
                    }
                }
            }, 100);
        },

        _insertSlot: function (section, group, position_or_slot, slot, after) {
            var i = 0;

            if (angular.isObject(position_or_slot)) {
                i = group.slots.indexOf(position_or_slot);
            }
            if (after && group.slots.length) {
                i += 1;
            }

            if (['text', 'image'].indexOf(slot.type) >= 0) {
                if (!slot.settings) slot.settings = {};
                if (!slot.settings.classes) slot.settings.classes = [];
                if (slot.settings.classes.indexOf('align-left') == -1 && slot.settings.classes.indexOf('align-right') == -1 && slot.settings.classes.indexOf('align-cener') == -1) {
                    if (slot.type == 'text') {
                        slot.settings.classes.push('align-left');
                    } else {
                        slot.settings.classes.push('align-center');
                    }
                }
            }

            group.slots.splice(i, 0, slot);

            return group.slots[i];
        },
        _insertGroup: function (section, group, slot_or_index, after) {
            var slot_index = slot_or_index;
            if (angular.isObject(slot_index)) {
                slot_index = group.slots.indexOf(slot_index);
            }
            if (slot_index && !after) {
                slot_index -= 1;
            }

            var group_index = section.groups.indexOf(group) + 1;
            slots = angular.copy(group.slots.splice(slot_index + 1, group.slots.length - slot_index));
            section.groups.splice(group_index, 0, {slots: slots, settings: {}});
            return section.groups[group_index];
        },
        _insertSection: function (section, data, after) {
            var index = currentScope.sections.indexOf(section);
            if (after) index += 1;
            currentScope.sections.splice(index, 0, data);
            return currentScope.sections[index];
        },

        _getSlotService: function (type) {
            var slot = editing.detectedSlots[type];
            if (slot && slot.service) {
                return slot.service;
            }
            return null;
        },
        getSlotService: function () {
            var slot = editing.detectedSlots[editing.slot.type];
            if (slot && slot.service) {
                return slot.service;
            }
            return null;
        },

        sortableSection: {
            group: 'section',
            animation: 1000,
            dataIdAttr: 'data-section-id',
            ghostClass: 'section-ghost'
        },
        sortableSlot: {
            group: 'slot',
            animation: 1000,
            dataIdAttr: 'data-slot-id',
            ghostClass: 'slot-ghost'
        },

        shortcuts: {},

        registerShortcut: function (shortcut, callback) {
            editing.shortcuts[shortcut] = callback;
        },

        unregisterShortcut: function (shortcut) {
            editing.shortcuts[shortcut] = null;
        }
    };


    var admin_pw = 'fufadmin'.toUpperCase(), admin_state = 0;

    document.addEventListener('keyup', function (e) {
        var target;
        if (!currentScope) return;

        if (e.target) target = e.target;
        else if (e.srcElement) target = e.srcElement;
        if (target.nodeType == 3) target = target.parentNode;

        if (target.contentEditable == 'true' || target.contenteditable == 'true' || target.tagName == 'INPUT' || target.tagName == 'TEXTAREA') {
            return;
        }
        if (e.shiftKey || e.altKey) {
            return;
        }

        if (!currentScope.admin_enabled) {
            if (e.keyCode == admin_pw.charCodeAt(admin_state)) {
                admin_state += 1;
                if (admin_state >= admin_pw.length) {
                    currentScope.admin_enabled = true;
                }
            } else {
                admin_state = 0;
            }
        }

        var KEY_ESCAPE = 27;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;
        var KEY_REMOVE = 46;

        if (e.keyCode == KEY_ESCAPE) {
            if (editing.mode == 'select') {
                return;
            } else if (editing.mode != 'select') {
                editing.switchMode('select');
            } else {
                return;
            }
        } else if (e.keyCode == KEY_LEFT && editing.shortcuts.left) {
            editing.shortcuts.left();

        } else if (e.keyCode == KEY_RIGHT && editing.shortcuts.right) {
            editing.shortcuts.right();

        } else if ((editing.mode == 'edit' || editing.mode == 'select') && e.keyCode == 'P'.charCodeAt(0) && currentScope.toggleLeftAllowed()) { // todo: toggleLeftAllowed -> right
            currentScope.toggleRight();

        } else if ((editing.mode == 'edit' || editing.mode == 'select') && e.keyCode == 'M'.charCodeAt(0) && currentScope.toggleLeftAllowed()) {
            currentScope.toggleLeft();

        } else if ((editing.mode == 'edit' || editing.mode == 'select') && e.keyCode == 'I'.charCodeAt(0) && e.ctrlKey) {
            currentScope.showGridBottomSheet();

        } else if (editing.mode == 'edit' && e.keyCode == 'C'.charCodeAt(0) && e.ctrlKey) {
            editing.switchMode('copy');

        } else if (editing.mode == 'edit' && e.keyCode == 'X'.charCodeAt(0) && e.ctrlKey) {
            editing.switchMode('cut');

        } else if (editing.mode == 'edit' && e.keyCode == KEY_REMOVE) {
            editing.remove();

        } else {
            return;
        }

        currentScope.$applyAsync();
        e.preventDefault();
        e.stopPropagation();
    });

    return editing;
}]);